import DPA, { connect } from 'servisofts-page';
import { Parent } from '.';
import { SNavigation, SPopup, SText } from 'servisofts-component';
import Model from '../../../Model';
import SSocket from 'servisofts-socket'

class index extends DPA.new {
    constructor(props) {
        super(props, {
            Parent: Parent,
            excludes: ["key", "fecha_on", "key_usuario", "estado", "key_restaurante", "url", "params"]
        });
    }

    $allowAccess() {
        return Model.usuarioPage.Action.getPermiso({ url: Parent.path, permiso: "new" })
    }

    // $inputs() {
    //     var inp = super.$inputs();
    //     inp.busqueda = {
    //         label: "Busqueda",
    //         type: "text",
    //         defaultValue: "",
    //     }
    //     return inp;
    // }

    $onSubmit(data) {
        // if (data?.busqueda) {
        //     data.url = "/buscar"
        //     data.params = { "busqueda": data.busqueda }
        // }

        if (!data.tiempo_reinicio) {
            data.tiempo_reinicio = 0;
        }

        if (data.tiempo) {
            data.tiempo = data.tiempo * 1000; // Convertir a milisegundos
        }



        Parent.model.Action.registro({
            data: data,
            key_usuario: Model.usuario.Action.getKey(),
        }).then((resp) => {

            this.form.uploadFiles(
                SSocket.api.root + "upload/popup_inicio/" + resp.data.key
            );

            SNavigation.goBack();
        }).catch(e => {
            console.error(e);
        })
    }
}

export default connect(index);